import angular from "angular";
import moment from "moment-timezone";

import Assert from "tbAssert";

import uiRouterModule from "@uirouter/angularjs";

import TrackerBaseReportsConstants from "./Constants";
import ReportConfiguration from "./ReportConfiguration";
import DependencyListBuilder from "../../utility/DependencyListBuilder";

import SomeDaysEventsReportController from "./SomeDaysEventsReportController";

import CurrentTimeZoneServiceModule from "../../services/CurrentTimeZoneService";

const reportConfigurationNames = Object.freeze({
    Today: "Today",
    Tomorrow: "Tomorrow",
    Yesterday: "Yesterday",
    DayFromUrl: "AnyDay"
});

function GetTodaysDate(CurrentTimeZone) {
    let currentTZ = CurrentTimeZone.get();
    let targetDate = moment().tz(currentTZ);
    return targetDate;
}
GetTodaysDate.$inject = [ "CurrentTimeZone" ];

function GetTomorrowsDate(CurrentTimeZone) {
    let currentTZ = CurrentTimeZone.get();
    let targetDate = moment().tz(currentTZ).add(1,"d");
    return targetDate;
}
GetTomorrowsDate.$inject = ["CurrentTimeZone"];

function GetYesterdaysDate(CurrentTimeZone) {
    let currentTZ = CurrentTimeZone.get();
    let targetDate = moment().tz(currentTZ).subtract(1, "d");
    return targetDate;
}
GetYesterdaysDate.$inject = [ "CurrentTimeZone" ];

function GetDateFromUrl(CurrentTimeZone, $transition$) {
    let isOk = false;
    let targetDate = null;

    let currentTZ = CurrentTimeZone.get();
    let currentStateParams = $transition$.params();

    let yearPart = parseInt(currentStateParams.year, 10);
    let monthPart = parseInt(currentStateParams.month, 10);
    let dayPart = parseInt(currentStateParams.day, 10);

    if ((Number.isInteger(yearPart)) &&
        (Number.isInteger(monthPart)) &&
        (Number.isInteger(dayPart))) {

        --monthPart;

        targetDate = moment({
            year: yearPart,
            month: monthPart,
            day: dayPart
        }).tz(currentTZ);

        if (targetDate.isValid())
        {
            isOk = true;
        }
    }

    if (isOk === true) {
        return targetDate;
    }
    else {
        return moment().tz(currentTZ);
    }
}
GetDateFromUrl.$inject = [ "CurrentTimeZone", "$transition$" ];

const reportConfigurationsTable = new Map([
    [reportConfigurationNames.Today, {
        config: new ReportConfiguration({
            reportDisplayName: "Today's Tracking",
            reportStateName: "todaysEventsReport"
        }),
        url: "/todays-events",
        getTargetDateFn: GetTodaysDate
    }],
    [reportConfigurationNames.Tomorrow, {
        config: new ReportConfiguration({
            reportDisplayName: "Tomorrow's Tracking",
            reportStateName: "tomorrowsEventsReport"
        }),
        url: "/tomorrows-events",
        getTargetDateFn: GetTomorrowsDate
    }],
    [reportConfigurationNames.Yesterday, {
        config: new ReportConfiguration({
            reportDisplayName: "Yesterday's Tracking",
            reportStateName: "yesterdaysEventsReport",
            showReportInMenu: false
        }),
        url: "/yesterdays-events",
        getTargetDateFn: GetYesterdaysDate
    }],
    [reportConfigurationNames.DayFromUrl, {
        config: new ReportConfiguration({
            reportDisplayName: "Scheduled Events Report",
            reportStateName: "scheduledEventsReport",
            showReportInMenu: false
        }),
        url: "/scheduled-events/{year}/{month}/{day}",
        getTargetDateFn: GetDateFromUrl
    }]
]);

function SomeDaysEventsReportConfiguration($stateProvider) {
    Assert.StrictAssert($stateProvider != null, "Assertion Failed: Missing UI Router State Provider Dependency");

    let someDaysEventsReportStateBase = {
        template: SomeDaysEventsReportController.template,
        controller: SomeDaysEventsReportController,
        controllerAs: SomeDaysEventsReportController.controllerAs,
        data: {
            featureToggles: {
                sendReportFeature: true
            }
        }
    };

    Object.values(reportConfigurationNames).forEach((reportKey) => {

        let reportRootStateName = TrackerBaseReportsConstants.rootStateName;
        let reportConfigData = reportConfigurationsTable.get(reportKey);
        let reportConfig = reportConfigData.config;

        $stateProvider.state(
            `${reportRootStateName}.${reportConfig.stateName}`,
            angular.extend({
                url: reportConfigData.url,
                resolve: {
                    reportTargetDate: reportConfigData.getTargetDateFn
                }
            }, someDaysEventsReportStateBase));
    });
}

SomeDaysEventsReportConfiguration.$inject = [ "$stateProvider" ];

SomeDaysEventsReportConfiguration.dependencies = [
    uiRouterModule,
    CurrentTimeZoneServiceModule
];

const someDaysEventsReportModuleDependencies = DependencyListBuilder([
    SomeDaysEventsReportController.dependencies,
    SomeDaysEventsReportConfiguration.dependencies
]);

export default {
    moduleName: angular
        .module(
            "trackerbase-app.views.trackerbase-reports.some-days-events-report",
            someDaysEventsReportModuleDependencies
        )
        .config(SomeDaysEventsReportConfiguration)
        .name,
    configs: Array.from(reportConfigurationsTable.values()).map((fullConfig) => fullConfig.config)
};



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/SomeDaysEventsReport.js
// module id = x6c2
// module chunks = 1